import { computed } from 'vue';
import useRwdImg from '@/hooks/useRwdImg';

const volumes1 = computed(() => useRwdImg('ip_pc_volume_1', false));
const volumes2 = computed(() => useRwdImg('ip_pc_volume_2', false));
const volumes3 = computed(() => useRwdImg('ip_pc_volume_3', false));
const volumes4 = computed(() => useRwdImg('ip_pc_volume_4', false));
const volumes5 = computed(() => useRwdImg('ip_pc_volume_5', false));
const volumes6 = computed(() => useRwdImg('ip_pc_volume_6', false));
const volumes7 = computed(() => useRwdImg('ip_pc_volume_7', false));
const volumes8 = computed(() => useRwdImg('ip_pc_volume_7', false));
const signal1 = computed(() => useRwdImg('ip_pc_signal_1', false));
const signal2 = computed(() => useRwdImg('ip_pc_signal_2', false));
const signal3 = computed(() => useRwdImg('ip_pc_signal_3', false));
const signal4 = computed(() => useRwdImg('ip_pc_signal_4', false));
const signal5 = computed(() => useRwdImg('ip_pc_signal_5', false));
const signal6 = computed(() => useRwdImg('ip_pc_signal_6', false));
const signal7 = computed(() => useRwdImg('ip_pc_signal_7', false));
const musicBgActive = computed(() => useRwdImg('ip_pc_music_bg_active', false));
export function useImgSrc() {
  return {
    volumes1: volumes1.value.imgSrc,
    volumes2: volumes2.value.imgSrc,
    volumes3: volumes3.value.imgSrc,
    volumes4: volumes4.value.imgSrc,
    volumes5: volumes5.value.imgSrc,
    volumes6: volumes6.value.imgSrc,
    volumes7: volumes7.value.imgSrc,
    volumes8: volumes8.value.imgSrc,
    signal1: signal1.value.imgSrc,
    signal2: signal2.value.imgSrc,
    signal3: signal3.value.imgSrc,
    signal4: signal4.value.imgSrc,
    signal5: signal5.value.imgSrc,
    signal6: signal6.value.imgSrc,
    signal7: signal7.value.imgSrc,
    musicBgActive: musicBgActive.value.imgSrc,
  }
}
